<template>
  <div id="users" style="display: flex; align-content: center" class="mt-4">
    <table class="table table-hover shadow-lg">
      <thead class="thead-dark">
      <tr>
        <th scope="col">Id</th>
        <th scope="col">Name</th>
        <th scope="col">email</th>
        <th scope="col">role</th>
        <th scope="col" style="width: 25vh">
          <button class="btn text-success btn-link" v-on:click="userCreate"><i class="fas fa-plus"></i></button>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in items" v-bind:key="item.id">
        <td>
          {{ item.id }}
        </td>
        <td>
          {{ item.name }}
        </td>
        <td>
          {{ item.email }}
        </td>
        <td>
          {{ item.role }}
        </td>

        <td id="button-sector-edit-delete">

          <button class="btn text-secondary btn-link" v-bind:value="item.id" v-on:click="userEdit(item.id)">
            <i class="far fa-edit"></i>
          </button>
          <button class="btn text-danger  btn-link " v-bind:value="item.id"
                  v-on:click="userDelete(item.id)">
            <i class="fas fa-trash-alt"></i>
          </button>

        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import axios from "axios";
import tokenRefresh from "@/utils/tokenRefresh";
import Swal from "sweetalert2";
import statusCheck from "@/utils/statusCheck";

export default {
  name: "users",
  data() {
    return {
      items: '',

    }
  },
  mounted() {
    if (!localStorage.getItem('reloaded')) {
      localStorage.setItem('reloaded', '1');
      location.reload();
    }
    axios.get(process.env.VUE_APP_CRAWLING_URL + '/api/users')
        .then((response) => {
              var data = [];
              for (let i = 0; i < response.data.length; i++) {
                data[i] = {
                  "name": response.data[i]['name'],
                  "email": response.data[i]['email'],
                  "id": response.data[i]['id'],
                  "role": response.data[i]['roles'][0]['name']
                }
              }
              this.items = data;
            }
        )
        .catch(function (error) {
              statusCheck(error.response.status);
            }
        )
  },
  methods: {
    userEdit: function (id) {
      tokenRefresh();
      this.$router.push({name: "user-edit", params: {id: id}});
    },

    userDelete: function (id) {
      tokenRefresh();
      Swal.fire({
        title: 'Info!',
        text: 'Are you sure',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel',
        allowOutsideClick: true,

      })
          .then((response) => {
                if (response.isConfirmed)
                  axios.delete(process.env.VUE_APP_CRAWLING_URL + "/api/users/" + id)
                      .then((response) => {
                            if (response.status === 200) {
                              Swal.fire({
                                title: 'Success!',
                                text: 'User deleted',
                                icon: 'success',
                                confirmButtonText: 'Ok',
                                allowOutsideClick: true,
                              })
                                  .then(() => {
                                        this.$router.go();
                                      }
                                  );
                            }

                          }
                      )
              }
          )
    },
    userCreate: function () {
      tokenRefresh();
      this.$router.push({name: "user-create"});
    }
  }
}
</script>
